const angular = require('angular')
const settingCtrl = require('./settingCtrl')
require('./signature/module')
require('./changePassword/module')
require('./sharedMailbox/module')

module.exports = angular
  .module('hxphone.setting', [
    'hxphone.services',
    'hxphone.signature',
    'hxphone.changePassword',
    'hxphone.sharedMailbox',
  ])
  .controller('settingCtrl', settingCtrl)
  /*
  * 需要放在ionic module前执行
  * 解决 ionic-sdk/release/js/ionic-angular.js（onHardwareBackButton） 引入的在钉钉无法返回退出问题
  * 暂定大方向往H5的方向靠，功能上不依赖native能力
  */
  .run(['$ionicPlatform', function ($ionicPlatform) {
    $ionicPlatform.registerBackButtonAction = _ => angular.noop
  }])



// WEBPACK FOOTER //
// ./src/js/setting/module.js